$(function(e){

    var OfficeRequest = {
        load: function(){
            $.ajax({
                url: $('[js-office-requests-container]').data('url'),
                type: 'post',
                success: function(data){
                    $('[js-office-requests-list]').html(data);
                }
            })
        }
    };

    $('[js-office-request-form-choose]').on('change', function(){
        $('.office-requests-forms__item').hide();
        $('.office-requests-forms__item[data-id="'+$(this).val()+'"]').show();
    });

    $('.office-requests [js-generated-form]').on('success', function(){
        OfficeRequest.load();
    });

    $('body').on('click', '[js-office-request-open-result]', function(e){
        e.preventDefault();
        var $elem = $(this);
        if($elem.data('blocked')) return;
        $elem.data('blocked', true);

        $.ajax({
            url: $('[js-office-requests-container]').data('url-result'),
            data: {result_id: $elem.data('id')},
            type: 'post',
            success: function(data){
                $$.openModal($(data));
                $elem.data('blocked', false);
            }
        });
    });

});

